import { ILinkedAccount } from '../../types';
import { LIMITS_TYPES } from '../BankTransfer/constants';
import { IFeeData } from '../../store/createBankTransferSlice';
import { convertValueToUSD } from '../../helpers/currency.helper';

export const getLinkedAccount = (accounts: ILinkedAccount[], externalId: string) => accounts?.find((account) => account.externalId === externalId);

export const getPayeeDetailsText = (selectedLinkedAccount: ILinkedAccount | null) => {
  if (!selectedLinkedAccount) return '';
  const { institutionName, displayName, mask } = selectedLinkedAccount;
  return `${institutionName} - ${displayName} ${mask}`;
};

export const getLimitsErrorResourceKey = (lowestLimitKey: string) => {
  switch (lowestLimitKey) {
    case LIMITS_TYPES.BALANCE:
      return 'ACH_OUT_REVIEW.ACH_OUT_AMOUNT.LIMITS.BALANCE.ERROR';
    case LIMITS_TYPES.DAILY:
      return 'ACH_OUT_REVIEW.ACH_OUT_AMOUNT.LIMITS.DAILY.ERROR';
    case LIMITS_TYPES.MONTHLY:
      return 'ACH_OUT_REVIEW.ACH_OUT_AMOUNT.LIMITS.MONTHLY.ERROR';
    default:
      return '';
  }
};

export const buildSuccessBoxTransferData = (rowTitles: string[], selectedLinkedAccount: ILinkedAccount | null, feeData: IFeeData | null, amount: string) => {
  const data = [];
  const {
    institutionName,
    displayName,
    mask,
    routingNumber,
    accountId,
  } = selectedLinkedAccount || {};
  const fee = feeData?.fee && feeData.fee > 0 ? convertValueToUSD(feeData.fee, 2) : 'Free';
  data.push({ title: rowTitles?.[0] || '', value: convertValueToUSD(Number(amount), 2) });
  data.push({ title: rowTitles?.[1] || '', value: institutionName || '', value2: `${displayName} ${mask}` });
  data.push({ title: rowTitles?.[2] || '', value: routingNumber || '' });
  data.push({ title: rowTitles?.[3] || '', value: accountId || '' });
  data.push({ title: rowTitles?.[4] || '', value: feeData?.arrivalDate || '' });
  data.push({ title: rowTitles?.[5] || '', value: fee });
  return data;
};

export const getRowTitlesForSuccessPage = (t: any) => ([
  t('SUCCESS_PAGE.ROWS.AMOUNT'),
  t('SUCCESS_PAGE.ROWS.TO'),
  t('SUCCESS_PAGE.ROWS.ROUTING_NUMBER'),
  t('SUCCESS_PAGE.ROWS.ACCOUNT_NUMBER'),
  t('SUCCESS_PAGE.ROWS.ESTIMATED_DELIVERY'),
  t('SUCCESS_PAGE.ROWS.FEE'),
]);
